import React from "react";
import { Compass, HardHat, Cpu } from "lucide-react";
import { services } from "../mock";

const iconMap = { Compass, HardHat, Cpu };

export default function Practice() {
  return (
    <section id="services" className="section-warm grain">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-20 md:py-28">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-8">
            <p className="eyebrow eyebrow-line">Our Practice</p>
            <h2 className="font-serif-display mt-6 text-[2.2rem] md:text-[3.2rem] leading-[1.05] text-[#2a3325]">
              Three lines of <span className="italic-accent">independent</span> oversight.
            </h2>
          </div>
          <div className="lg:col-span-4 flex items-end">
            <p className="text-[#4d5a45] leading-relaxed">
              Each line can be engaged on its own or combined into a single, written mandate covering purchase, refurbishment, and everyday portfolio operation.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-14">
          {services.map((s) => {
            const Icon = iconMap[s.icon];
            return (
              <div key={s.n} className="card-soft p-8 flex flex-col rounded-sm">
                <div className="flex items-start justify-between">
                  <span className="eyebrow">Service · {s.n}</span>
                  <Icon className="w-6 h-6 text-[#8a9a6b]" strokeWidth={1.4} />
                </div>
                <h3 className="font-serif-display text-[1.7rem] leading-tight mt-6 text-[#2a3325]">{s.title}</h3>
                <p className="italic-accent mt-2 text-[1.02rem]">{s.subtitle}</p>
                <p className="mt-5 text-[#4d5a45] leading-relaxed text-sm">{s.desc}</p>
                <ul className="mt-5 space-y-2">
                  {s.bullets.map((b) => (
                    <li key={b} className="text-sm text-[#3d4838] flex gap-3">
                      <span className="mt-1.5 inline-block w-1.5 h-1.5 rounded-full bg-[#8a9a6b]" />
                      {b}
                    </li>
                  ))}
                </ul>
                <div className="divider mt-7" />
                <p className="eyebrow mt-4">{s.fee}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
